/* Sidebar de filtre Atelier — filtrare + sortare in browser, fara dependenta de
   Search & Discovery. Starea se reflecta in URL (?densitate=80,120&culoare=Verde&pmax=250)
   ca sa fie share-uibila si sa reziste la refresh. */
(function () {
  const root = document.querySelector('[data-atelier-collection]');
  if (!root) return;

  const grid = root.querySelector('[data-atelier-grid]');
  const items = grid ? Array.from(grid.querySelectorAll('[data-atelier-product]')) : [];
  const resultEl = root.querySelector('[data-atelier-result]');
  const noResEl = root.querySelector('[data-atelier-noresults]');
  const sortSel = root.querySelector('[data-atelier-sort]');
  const clearBtns = root.querySelectorAll('[data-atelier-clear]');
  const activeCountEl = root.querySelector('[data-atelier-active-count]');

  const filterInputs = Array.from(root.querySelectorAll('[data-atelier-filter]'));
  const priceMinInput = root.querySelector('[data-atelier-price-min]');
  const priceMaxInput = root.querySelector('[data-atelier-price-max]');
  const rangeMin = root.querySelector('[data-atelier-range-min]');
  const rangeMax = root.querySelector('[data-atelier-range-max]');
  const sliderFill = root.querySelector('[data-atelier-slider-fill]');

  const PRICE_MIN = parseInt(root.dataset.priceMin || '0', 10);
  const PRICE_MAX = parseInt(root.dataset.priceMax || '0', 10);

  // Sorteaza numeric grupele de facete marcate (densitate, lungime)
  root.querySelectorAll('[data-atelier-sortnum]').forEach((box) => {
    const rows = Array.from(box.querySelectorAll('.at-check'));
    rows.sort((a, b) => (+a.dataset.sortval || 0) - (+b.dataset.sortval || 0));
    rows.forEach((r) => box.appendChild(r));
  });

  // —— drawer mobil ——
  const filtersEl = root.querySelector('[data-atelier-filters]');
  root.querySelectorAll('[data-atelier-filter-open]').forEach((b) =>
    b.addEventListener('click', () => {
      filtersEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    })
  );
  root.querySelectorAll('[data-atelier-filter-close]').forEach((b) =>
    b.addEventListener('click', closeDrawer)
  );
  function closeDrawer() {
    filtersEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // —— citire/scriere URL ——
  function readURL() {
    const p = new URLSearchParams(location.search);
    filterInputs.forEach((inp) => {
      const key = inp.dataset.atelierFilter;
      const raw = p.get(key);
      if (!raw) return;
      const vals = raw.split(',');
      if (vals.includes(inp.value)) inp.checked = true;
    });
    if (p.get('pmin') && priceMinInput) priceMinInput.value = p.get('pmin');
    if (p.get('pmax') && priceMaxInput) priceMaxInput.value = p.get('pmax');
    if (p.get('sort') && sortSel) sortSel.value = p.get('sort');
    syncRangeFromInputs();
  }

  function writeURL() {
    const p = new URLSearchParams();
    const groups = {};
    filterInputs.forEach((inp) => {
      if (!inp.checked) return;
      (groups[inp.dataset.atelierFilter] ||= []).push(inp.value);
    });
    Object.entries(groups).forEach(([k, v]) => p.set(k, v.join(',')));
    if (priceMinInput && +priceMinInput.value > PRICE_MIN) p.set('pmin', priceMinInput.value);
    if (priceMaxInput && +priceMaxInput.value < PRICE_MAX) p.set('pmax', priceMaxInput.value);
    if (sortSel && sortSel.value !== 'manual') p.set('sort', sortSel.value);
    const qs = p.toString();
    history.replaceState(null, '', qs ? '?' + qs : location.pathname);
  }

  // —— range slider ——
  function syncRangeFromInputs() {
    if (!rangeMin) return;
    rangeMin.value = clamp(+priceMinInput.value, PRICE_MIN, PRICE_MAX);
    rangeMax.value = clamp(+priceMaxInput.value, PRICE_MIN, PRICE_MAX);
    paintSlider();
  }
  function paintSlider() {
    if (!sliderFill) return;
    const span = PRICE_MAX - PRICE_MIN || 1;
    const a = ((+rangeMin.value - PRICE_MIN) / span) * 100;
    const b = ((+rangeMax.value - PRICE_MIN) / span) * 100;
    // fundal in 3 zone: gri pana la a, verde intre a si b, gri dupa b
    sliderFill.style.setProperty('--at-a', a + '%');
    sliderFill.style.setProperty('--at-b', b + '%');
  }
  function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }

  if (rangeMin) {
    rangeMin.addEventListener('input', () => {
      if (+rangeMin.value > +rangeMax.value) rangeMin.value = rangeMax.value;
      priceMinInput.value = rangeMin.value;
      paintSlider(); apply();
    });
    rangeMax.addEventListener('input', () => {
      if (+rangeMax.value < +rangeMin.value) rangeMax.value = rangeMin.value;
      priceMaxInput.value = rangeMax.value;
      paintSlider(); apply();
    });
    [priceMinInput, priceMaxInput].forEach((inp) =>
      inp.addEventListener('change', () => { syncRangeFromInputs(); apply(); })
    );
  }

  // —— filtrare ——
  function selected(key) {
    return filterInputs
      .filter((i) => i.dataset.atelierFilter === key && i.checked)
      .map((i) => i.value);
  }

  function matches(item) {
    const price = parseFloat(item.dataset.price || '0');
    if (priceMinInput && price < +priceMinInput.value) return false;
    if (priceMaxInput && price > +priceMaxInput.value) return false;

    const dens = selected('densitate');
    if (dens.length && !dens.includes(item.dataset.densitate)) return false;

    const dim = selected('dimensiune');
    if (dim.length && !dim.includes(item.dataset.dimensiune)) return false;

    const lng = selected('lungime');
    if (lng.length && !lng.includes(item.dataset.lungime)) return false;

    const mat = selected('material');
    if (mat.length && !mat.includes(item.dataset.material)) return false;

    const cul = selected('culoare');
    if (cul.length) {
      const have = (item.dataset.culoare || '').split(',').filter(Boolean);
      if (!cul.some((c) => have.includes(c))) return false;
    }

    const stoc = selected('stoc');
    if (stoc.length && item.dataset.instock !== '1') return false;

    return true;
  }

  function sortItems(list) {
    const v = sortSel ? sortSel.value : 'manual';
    if (v === 'manual') return list;
    const arr = list.slice();
    arr.sort((a, b) => {
      switch (v) {
        case 'price-asc': return +a.dataset.price - +b.dataset.price;
        case 'price-desc': return +b.dataset.price - +a.dataset.price;
        case 'title-asc': return a.dataset.title.localeCompare(b.dataset.title, 'ro');
        case 'title-desc': return b.dataset.title.localeCompare(a.dataset.title, 'ro');
        case 'created-desc': return +b.dataset.created - +a.dataset.created;
        default: return 0;
      }
    });
    return arr;
  }

  function apply() {
    let shown = 0;
    items.forEach((it) => {
      const ok = matches(it);
      it.hidden = !ok;
      if (ok) shown++;
    });

    // reordonare
    sortItems(items.filter((it) => !it.hidden)).forEach((it) => grid.appendChild(it));

    if (resultEl) {
      resultEl.textContent = shown === items.length
        ? `${shown} produse`
        : `${shown} din ${items.length} produse`;
    }
    if (noResEl) noResEl.hidden = shown !== 0;

    const activeN = filterInputs.filter((i) => i.checked).length
      + (priceMinInput && +priceMinInput.value > PRICE_MIN ? 1 : 0)
      + (priceMaxInput && +priceMaxInput.value < PRICE_MAX ? 1 : 0);
    clearBtns.forEach((b) => (b.hidden = activeN === 0));
    if (activeCountEl) {
      activeCountEl.hidden = activeN === 0;
      activeCountEl.textContent = activeN;
    }

    writeURL();
  }

  filterInputs.forEach((inp) => inp.addEventListener('change', apply));
  if (sortSel) sortSel.addEventListener('change', apply);
  clearBtns.forEach((b) =>
    b.addEventListener('click', () => {
      filterInputs.forEach((i) => (i.checked = false));
      if (priceMinInput) priceMinInput.value = PRICE_MIN;
      if (priceMaxInput) priceMaxInput.value = PRICE_MAX;
      syncRangeFromInputs();
      apply();
    })
  );

  readURL();
  apply();
})();
